const mountMaisonMadinaDropCountdown = (root) => {
  if (root.dataset.countdownMounted === 'true') return;
  const deadline = new Date(root.dataset.deadline).getTime();
  const timer = root.querySelector('[data-drop-timer]');
  const live = root.querySelector('[data-drop-live]');
  const days = root.querySelector('[data-drop-days]');
  const hours = root.querySelector('[data-drop-hours]');
  const minutes = root.querySelector('[data-drop-minutes]');
  const seconds = root.querySelector('[data-drop-seconds]');
  if (!Number.isFinite(deadline) || !timer || !live || !days || !hours || !minutes || !seconds) return;
  root.dataset.countdownMounted = 'true';
  const pad = (value) => String(value).padStart(2, '0');
  const update = () => {
    const remaining = deadline - Date.now();
    if (remaining <= 0) {
      timer.hidden = true;
      live.hidden = false;
      root.dataset.dropLive = 'true';
      window.clearInterval(root.countdownInterval);
      return;
    }
    days.textContent = pad(Math.floor(remaining / 86400000));
    hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
    minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
    seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
  };
  update();
  root.countdownInterval = window.setInterval(update, 1000);
};
const mountMaisonMadinaDropCountdowns = (scope = document) => scope.querySelectorAll('[data-mm-drop-countdown]').forEach(mountMaisonMadinaDropCountdown);
mountMaisonMadinaDropCountdowns();
document.addEventListener('shopify:section:load', (event) => mountMaisonMadinaDropCountdowns(event.target));
